import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import FeaturesShowcase from '../components/FeaturesShowcase';
import PremiumFeatures from '../components/PremiumFeatures';
import IntegrationsGrid from '../components/IntegrationsGrid';
import PricingTable from '../components/PricingTable';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';

export default function Home() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <FeaturesShowcase limit={4} />
      <PremiumFeatures />
      <IntegrationsGrid />
      <PricingTable compact />
      <FAQ />
      <CTA />
    </>
  );
}
